var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showValue)?_c('div',{staticClass:"number-argument"},[_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.renderValue))]),(_vm.renderSuffix)?_c('span',{staticClass:"suffix"},[_vm._v(" "+_vm._s(_vm.suffix))]):_vm._e()]):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }